export default __webpack_public_path__ + "static/media/1.b31b4e29.png";